export default "__VITE_ASSET__ae83405c__"